module.exports = __webpack_public_path__ + "static/img/2.f35b48e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/eng/2.png
// module id = qt7a
// module chunks = 0